import cn from 'clsx'
import * as React from 'react'
export type Props = {
  className?: string
  children?: any
  checked: boolean
  onMouseDown?: (...args: Array<any>) => any
  wrapText?: boolean
}

const Check = (props: Props): React.ReactElement<'div'> => {
  const { className, checked, onMouseDown, children, wrapText } = props
  const rootClass = checked ? 'RadioButtonCheck_On' : 'RadioButtonCheck_Off'
  return (
    <div
      className={cn(rootClass, className, {
        'RadioButtonCheck--WrapText': wrapText,
      })}
      onMouseDown={onMouseDown}
    >
      {children}
    </div>
  )
}

export default Check
